import React, { useState } from "react";
import { Button } from "antd";
import { isEmpty, isFunction } from "lodash";
import { DIALOG_TYPES } from "../hoc/Dialog/dialog";

// Button type constants
const BTN_TYPE_PRIMARY = "primary";
const BTN_TYPE_DANGER = "danger";
const BTN_TYPE_DEFAULT = "default";

/**
 * Props:
 * onOk: function
 * onCancel: function
 * okBtnText: string
 * okBtnType: string (antd type)
 * cancelBtnText: string
 * cancelBtnType: string (antd type)
 * content: JSX
 * headerLine1: string (optional, if content not provided)
 * headerLine2: string (optional, if content not provided)
 * okBtnProps: object (optional)
 * cancelBtnProps: object (optional)
 */
const NewConfirmDialog = ({
  onOk,
  onCancel,
  okBtnText = "Delete",
  okBtnType = BTN_TYPE_PRIMARY,
  cancelBtnText = "Cancel",
  cancelBtnType = BTN_TYPE_DEFAULT,
  content,
  headerLine1,
  headerLine2,
  okBtnProps = {},
  cancelBtnProps = {},
  onClose,
  isDanger = false,
}) => {
  const [okLoading, setOkLoading] = useState(false);

  const handleOk = async () => {
    setOkLoading(true);
    try {
      await onOk();
      onClose(DIALOG_TYPES.NEW_CONFIRM_DIALOG);
    } finally {
      setOkLoading(false);
    }
  };

  return (
    <div>
      <div className="mb-10">
        {!isEmpty(content) ? (
          content
        ) : (
          <div>
            {headerLine1 && <p className="text-sm text-default mt-2 mb-4">{headerLine1}</p>}
            {headerLine2 && <p className="text-sm m-0 text-default">{headerLine2}</p>}
          </div>
        )}
      </div>
      <div className="flex gap-2 mt-2">
        <Button
          type={okBtnType}
          danger={isDanger}
          onClick={handleOk}
          loading={okLoading}
          {...okBtnProps}
        >
          {okBtnText}
        </Button>
        <Button
          type={cancelBtnType}
          onClick={() =>
            isFunction(onCancel) ? onCancel() : onClose(DIALOG_TYPES.NEW_CONFIRM_DIALOG)
          }
          {...cancelBtnProps}
        >
          {cancelBtnText}
        </Button>
      </div>
    </div>
  );
};

export default NewConfirmDialog;
